import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css"
import "../../../assets/css/admin/allAdmins.module.css"
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import swal from "sweetalert";
import { Link } from "react-router-dom";
import { useAuth } from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";


const AdminGallery = () => {
    const { logout, user } = useAuth();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [gallery, setGallery] = useState([])
    const [searchParams, setSearchParams] = useSearchParams();
    const [loading, setLoading] = useState(false)
    const page = parseInt(searchParams.get("page")) || 1;
    const search = searchParams.get("search") || "";
    const showFilter = searchParams.get("show") || "";
    const limit = 10

    const [totalPages, setTotalPages] = useState(1);

    const getGallery = () => {
        setLoading(true)
        axios.get(`${baseUrl}/gallery/admin`, {
            params: {
                page,
                limit,
                show: showFilter || undefined,
                search: search || undefined
            }
        })
            .then(res => {
                setLoading(false)
                setGallery(res.data.gallery);
                setTotalPages(res.data.pagination.pages);
            })
            .catch(e => { setLoading(false); console.log(e) })
    }
    useEffect(() => {
        getGallery()
    }, [searchParams])

    const deleteGallery = (a) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    axios.delete(`${baseUrl}/gallery?id=${a._id}&image=${a.image}`)
                        .then(res => {
                            getGallery()
                            swal("Image has been deleted from gallery!", {
                                icon: "success",
                            });
                        }
                        )
                        .catch(err => {
                            console.log(err);
                            toast.error(err?.response?.data?.message || 'Something went wrong')
                        })

                }
            });
    }

    return (
        <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
            <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
                <SideBar />
            </aside>

            <main className={styles.mainContent}>
                <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
                <nav aria-label="breadcrumb" >
                    <ol className="breadcrumb">
                        <div className="d-flex flex-grow-1">
                            <li className="breadcrumb-item">
                                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                Gallery
                            </li>
                            <li className="breadcrumb-item">
                                <Link to='/admin/gallery/add' className="text-decoration-none">Add</Link>
                            </li>
                        </div>
                        <li className="nav-item dropdown">
                            <span
                                className="nav-link dropdown-toggle"
                                data-bs-toggle="dropdown"
                                href=""
                                role="button"
                                aria-expanded="false"
                            >
                                Welcome, {user.name}
                                <i className="ml-2 fa fa-angle-down"></i>
                            </span>
                            <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                                <li>
                                    <span className="dropdown-item" onClick={logout}>
                                        Logout
                                    </span>
                                </li>
                            </ul>
                        </li>
                    </ol>
                </nav>
                <div className={`container ${styles.container}`}>
                    <h4 className="mb-4"> Gallery</h4>
                    <div style={{ overflowX: 'scroll' }}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            {/* <input
                                type="text"
                                placeholder="Search by title..."
                                className="form-control w-25"
                                value={search}
                                onChange={(e) => {
                                    const newSearch = e.target.value;
                                    setSearchParams(prev => {
                                        const params = new URLSearchParams(prev);
                                        params.set("search", newSearch);
                                        params.set("page", 1);
                                        return params;
                                    });
                                }}

                            />*/}

                            <select
                                className="form-select w-25"
                                value={showFilter}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSearchParams(prev => {
                                        const params = new URLSearchParams(prev);
                                        params.set("show", value);
                                        params.set("page", 1); // reset page
                                        return params;
                                    });
                                }}

                            >
                                <option value="">All</option>
                                <option value="true">Published</option>
                                <option value="false">Draft</option>
                            </select>
                        </div>

                        <table>
                            <thead>
                                <tr>
                                    <td>Sr no.</td>
                                    <td style={{ minWidth: '140px' }}>Image</td>
                                    <td>Status</td>
                                    <td>Actions</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    loading &&
                                    <tr><td><img src="/assets/images/load-time.gif" width='50px' alt="loading" />Loading...</td></tr>
                                }
                                {
                                    !loading && gallery.length < 1 &&
                                    <tr><td>No Galley Image found</td></tr>
                                }
                                {!loading && gallery.length > 0 &&
                                    gallery.map((a, i) => {
                                        let sr = (page - 1) * limit + i + 1;
                                        return (
                                            <tr key={i}>
                                                <td>{sr}</td>
                                                <td><img src={`${baseUrl}${a.image}`} alt=""/></td>
                                                <td>{a.show ? 'Published' : 'Draft'}</td>
                                                <td>
                                                    <Link to={{
                                                        pathname: `/admin/gallery/edit/${a._id}`,
                                                        search: searchParams.toString(),
                                                    }}><button className="btn btn-success btn-sm m-1 p-1">Edit</button></Link>&nbsp;
                                                    <button onClick={() => deleteGallery(a)} className="btn btn-danger btn-sm m-1 p-1">Delete</button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                            </tbody>
                        </table>
                        {
                            gallery.length > 0 &&
                            <div className="d-flex justify-content-center align-items-center mt-3">
                                <button
                                    className="btn btn-outline-primary btn-sm mx-2"
                                    onClick={() => {
                                        setSearchParams(prev => {
                                            const params = new URLSearchParams(prev);
                                            params.set("page", page - 1);
                                            return params;
                                        });
                                    }}
                                    disabled={page === 1}
                                >
                                    Previous
                                </button>
                                <span>Page {page} of {totalPages}</span>
                                <button
                                    className="btn btn-outline-primary btn-sm mx-2"
                                    onClick={() => {
                                        setSearchParams(prev => {
                                            const params = new URLSearchParams(prev);
                                            params.set("page", page + 1);
                                            return params;
                                        });
                                    }}

                                    disabled={page === totalPages}
                                >
                                    Next
                                </button>
                            </div>
                        }

                    </div>
                </div>
            </main>
        </div>
    );
};

export default AdminGallery;
